import {gql} from '@apollo/client'

export const GET_PAGINATION_BLOG = gql`
query PaginationBlogDefinition($tag: String, $page: Int, $limit: Int, $site: String) {
    paginationBlogDefinition(tag: $tag, page: $page, limit: $limit, site: $site) {
      posts {
        title
        url
        video
        media_type
        image {
          alt
          path
        }
        tags {
          name
          slug
        }
        teaser
        content
      }
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
        itemCount
        pageCount
        perPage
        totalCount
      }
    }
  }
`
export const GET_PAGINATION_REVIEWS = gql`
query PaginationReviewsDefinition($page: Int, $limit: Int, $proId: Int, $site: String) {
  paginationReviewsDefinition(page: $page, limit: $limit, proId: $proId, site: $site) {
    posts {
      pro
      customer
      text
      stars
      place
    }
    pageInfo {
      currentPage
      hasNextPage
      hasPreviousPage
      itemCount
      pageCount
      perPage
      totalCount
    }
  }
}
`